export default {
	init() {
		let accept = document.querySelector('.js-cookie-accept');

		if (accept) {
			accept.addEventListener('click', (event) => {
				let warning = document.querySelector('.js-cookie-warning');
				warning.classList.add('c-cookie-warning--closed');
				document.cookie = "cookie-warning=accepted; expires=31 Dec 2030 12:00:00 UTC; path=/"; 
				event.preventDefault();
			});
		}	
	}
}